import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

export class CustomObservable {
    public static empty(): Observable<void> {
        return of(null).pipe(map(() => {}));
    }
}
